module.exports = __webpack_public_path__ + "static/media/middle@3x.fd471d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Skwiz/middle@3x.png
// module id = ./src/assets/Skwiz/middle@3x.png
// module chunks = 0